import LocalizedStrings from 'localized-strings';

import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

export default new LocalizedStrings({
  en: {
    cardIntroduction: 'If you are not the sole beneficial owner:',
    cta: 'Continue',
    intro:
      'We are legally obliged to ask you for certain information about the beneficial owners of your company.',
    moreInfoLink: 'Learn more about beneficial owners',

    step1Description:
      'This information must correspond to the company’s statutes',
    step1Title: {
      [ApplicantType.AccountHolder]: {
        [ApplicationType.CapitalDeposit]: 'Add your company’s key individuals',
        [ApplicationType.Standard]: 'Add all beneficial owners',
      },
      [ApplicantType.Mandatee]: {
        [ApplicationType.CapitalDeposit]:
          'Add all beneficial owners and all shareholders of the company',
        [ApplicationType.Standard]:
          'Add all beneficial owners and the legal representative of the account',
      },
    },
    step2Description: {
      [ApplicantType.AccountHolder]:
        'This invitation does not give access to the account',
      [ApplicantType.Mandatee]:
        'This invitation does not give access to the account (except for the holder)',
    },
    step2Title: 'They will receive an email invitation',

    step3Substeps: ['Some information about them', 'A proof of identity'],
    step3Title: 'They will have to fill in the following information:',

    title: 'Add your beneficial owners',
  },
  fr: {
    cardIntroduction:
      'Si vous n’êtes pas l’unique bénéficiaire effectif\u00A0:',
    cta: 'Continuer',
    intro:
      'Nous sommes tenus légalement de vous demander certaines informations à propos des bénéficiaires effectifs de votre entreprise.',
    moreInfoLink: 'En savoir plus à propos des bénéficiaires effectifs',

    step1Description:
      'Ces informations doivent correspondre aux statuts de l’entreprise',
    step1Title: {
      [ApplicantType.Mandatee]: {
        [ApplicationType.CapitalDeposit]:
          'Ajoutez tous les bénéficiaires effectifs et tous les actionnaires de l’entreprise',
        [ApplicationType.Standard]:
          'Ajoutez tous les bénéficiaires effectifs et la•le représentant•e légal•e du compte',
      },
      [ApplicantType.AccountHolder]: {
        [ApplicationType.CapitalDeposit]:
          'Ajoutez toutes les personnes clés de votre entreprise',
        [ApplicationType.Standard]: 'Ajoutez tous les bénéficiaires effectifs',
      },
    },
    step2Description: {
      [ApplicantType.AccountHolder]:
        'Cette invitation ne donne pas accès au compte',
      [ApplicantType.Mandatee]:
        'Cette invitation ne donne pas accès au compte (sauf pour le titulaire)',
    },
    step2Title: 'Nous leur enverrons une invitation par e-mail',

    step3Substeps: [
      'Quelques informations personnelles',
      'Une preuve d’identité',
    ],
    step3Title: 'Ils devront renseigner les informations suivantes\u00A0:',

    title: 'Bénéficiaires effectifs',
  },
} as const);
